import { useState } from 'react'
import { supabase } from '../lib/supabaseClient'
import { useToast } from '../components/useToast'
import { useLanguage } from '../hooks/useLanguage'

export default function SuggestionBox({ userId, userName }) {
  const { t } = useLanguage()
  const [open, setOpen] = useState(false)
  const [text, setText] = useState('')
  const [loading, setLoading] = useState(false)
  const toast = useToast()

  async function handleSubmit() {
    if (!text.trim()) return
    if (text.length > 500) {
      toast.error(t('sugerencia_muy_larga_titulo'), t('sugerencia_muy_larga_desc'))
      return
    }
    setLoading(true)
    try {
      const { data: modResult, error: modError } = await supabase.functions.invoke('moderate-text', {
        body: { text }
      })

      if (modError) throw modError

      if (!modResult.safe) {
        toast.error(t('sugerencia_no_permitido_titulo'), t('sugerencia_no_permitido_desc'))
        setLoading(false)
        return
      }

      const { error } = await supabase.from('suggestions').insert({
        user_id: userId,
        content: text.trim(),
        status: 'pending',
        author_name: userName || t('usuario_generico')
      })

      if (error) throw error

      toast.success(t('sugerencia_gracias_titulo'), t('sugerencia_gracias_desc'))
      setText('')
      setOpen(false)
    } catch (err) {
      console.error('Error enviando sugerencia:', err)
      toast.error(t('sugerencia_error_titulo'), t('sugerencia_error_desc'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(!open)}
        title={t('sugerencia_tooltip')}
        style={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          border: '1px solid rgba(255,255,255,0.12)',
          background: 'var(--color-surface)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          cursor: 'pointer',
          boxShadow: '0 4px 14px rgba(0,0,0,0.18)',
        }}
      >
        💡
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 10px)',
            right: 0,
            width: 280,
            background: 'var(--color-surface)',
            border: '1px solid var(--color-border)',
            borderRadius: 16,
            padding: 14,
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
            zIndex: 999,
          }}
        >
          <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>{t('sugerencia_titulo')}</div>
          <textarea
            value={text}
            onChange={e => setText(e.target.value)}
            maxLength={500}
            placeholder={t('sugerencia_placeholder')}
            style={{
              width: '100%',
              minHeight: 80,
              resize: 'vertical',
              background: 'var(--color-bg)',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: 10,
              padding: 10,
              fontSize: 13,
              color: 'var(--color-text)',
              outline: 'none',
              boxSizing: 'border-box',
            }}
          />
          <div style={{ fontSize: 10, color: 'var(--color-muted)', marginTop: 4, textAlign: 'right' }}>
            {text.length}/500
          </div>
          <button
            onClick={handleSubmit}
            disabled={loading || !text.trim()}
            style={{
              width: '100%',
              marginTop: 8,
              padding: '9px 0',
              borderRadius: 10,
              border: 'none',
              background: 'var(--color-primary)',
              color: 'white',
              fontWeight: 700,
              fontSize: 13,
              cursor: loading ? 'default' : 'pointer',
              opacity: loading ? 0.6 : 1,
            }}
          >
            {loading ? t('sugerencia_enviando') : t('sugerencia_enviar')}
          </button>
        </div>
      )}
    </div>
  )
}